export default {
  checkout: {
    // Fields

    /*********************************************************************************************
     * User configurable messages
     * TODO: Populate from API
     */
    privacyButton: ' informativa sulla privacy',
    privacyPolicyRequiredMessage: "Devi accettare l'informativa sulla privacy per continuare.",
    shareRating: 'Hai segnato {0}',
    shareComment: "Hai detto '{n}'",
    shareStaffApplaud: 'Hai applaudito {n}',
    shareSocialSubject: 'Consiglio questo posto!',
    shareSocialMsg: "L'ho appena visitato {n}. Questo è quello che penso: #feeditback",
    share: {
      title: 'Grazie per aver utilizzato 125 Data & Insights',
      link: {
        facebook: 'Condividi su Facebook',
        twitter: 'Condividi su X',
        email: 'Condividi tramite e-mail'
      },
      tip: {
        label: 'Lasciare un suggerimento'
      }
    },
    recommend: {
      skip: 'Saltare',
      suggestions: {
        title: "L'intelligenza artificiale ha generato feedback suggerito",
        description: 'Per favore condividi la tua esperienza',
        copy: 'Copia negli appunti',
        copied: 'Copiato',
        copiedToClipboard: 'Copiato negli appunti',
        error: 'Non ci sono informazioni sufficienti per generare una risposta informata',
        generate: 'Genera testo AI'
      }
    },
    email: 'Email',
    emailAlt: 'Condividilo via email',
    //dynamic use
    facebookAlt: 'Condividilo via Facebook',
    //dynamic use
    googleAlt: 'Crea una recensione su Google',
    //dynamic use
    thankYouHeader: 'Grazie',
    thankYouPermission: 'Grazie!',
    thankYouVoucher: 'Grazie per il tuo tempo! Ci auguriamo che possiate godervi il buono.',
    voucherScratchText: "Scratch here to\n    claim your voucher!",
    // TODO: Doesn't require a translation as there are no vouchers used by international clients
    weAreSorryHeader: 'Siamo spiacenti',
    weAreSorryText: 'Siamo spiacenti testo',
    uploadFileSizeError: 'Il tuo caricamento deve essere sotto {n}',
    uploadError: 'Errore sconosciuto',
    uploadDelete: 'Elimina foto',
    recaptchaCheckbox: 'Non sono un robot'
  }
};